(function () {
    'use strict';

    var controllerId = 'shell';
    angular.module('app').controller(controllerId,
        ['$rootScope', 'common', 'config', 'datacontext', 'sectionMenu', '$translate', 'tmhDynamicLocale', shell]);

    function shell($rootScope, common, config, datacontext, sectionMenu, $translate, tmhDynamicLocale) {
        var $location = common.$location;

        var vm = this;
        var logSuccess = common.logger.getLogFn(controllerId, 'success');
        var events = config.events;
        vm.busyMessage = 'Please wait ...';
        vm.isBusy = true;
        vm.spinnerOptions = {
            radius: 40,
            lines: 7,
            length: 0,
            width: 30,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#F58A00'
        };
        vm.oggi = new Date();
        //mi ricavo la lingua in uso
        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
        tmhDynamicLocale.set(vm.currentLanguage);

        vm.getSection = sectionMenu.getSection;
        vm.isSectionActive = sectionMenu.isSectionActive;
        vm.getClassIfActive = sectionMenu.getClassIfActive;        

        activate();

        function activate() {
            //logSuccess('Siverapp Angular loaded!', null, true);
            var promises = [WhoAmI()];
            common.activateController(promises, controllerId)
                .then(function () {
                    var url = $location.absUrl();
                    url = common.getUrl(url);
                    if (url == "/Ruolo_Super") {
                        $location.url("/dashboard_Super");
                    }
                    else if (url == "/Ruolo_Gestore") {
                        $location.url("/dashboard_Gestore");
                    }
                    else if (url == "/Ruolo_Docente") {
                        $location.url("/dashboard_Docente");
                    }
                    else if (url == "/Ruolo_Monitor") {
                        $location.url("/dashboard_Gestore");
                    }
                    else if (url == "/Ruolo_Studente") {
                        $location.url("/dashboard_Studente");
                    }
                    else if (url == "/Ruolo_Commerciale") {
                        $location.url("/dashboard_Commercial");
                    }
                    else if (url == "/Ruolo_AdminSL") {
                        $location.url("/dashboard_Admin");
                    }
                    else if (url == "/Ruolo_Stak") {
                        $location.url("/dashboard_Stakeholder");
                    }
                });

        }

        function toggleSpinner(on) { vm.isBusy = on; }

        $rootScope.$on('$routeChangeStart',
            function (event, next, current) { toggleSpinner(true); }
        );

        $rootScope.$on(events.controllerActivateSuccess,
            function (event, data) { toggleSpinner(false); }
        );

        $rootScope.$on(events.spinnerToggle,
            function (event, data) { toggleSpinner(data.show); }
        );

        function WhoAmI() {
            return datacontext.getWhoAmI().then(function (data) {
                if (!data) {
                    return vm.user = {};
                }
                $rootScope.userRoles = new Array();
                data.Ruoli.forEach(function (role) {
                    $rootScope.userRoles.push(role.Name);
                    var ruolo = setRuolo(role.Name);
                    data.Ruoli.Name = ruolo;
                });
                $rootScope.societa = data.Societa;                
                $rootScope.presenza = false;
                $rootScope.id = data.RisorsaId;
                $rootScope.name = data.Risorsa;
                $rootScope.username = data.Username;
                $rootScope.email = data.Email;
                $rootScope.licenza = data.Licenza;
                $rootScope.licenzaValida = data.LicenzaValida;
                $rootScope.dataLicenza = data.DataLicenza;
                $rootScope.anniScolastici = data.AnniScolastici;
                $rootScope.annoCorrente = data.AnnoCorrente;
                if (typeof ($rootScope.annoScolastico) === 'undefined')
                    $rootScope.annoScolastico = 0;
                $rootScope.mdTest = data.mdTest;
                $rootScope.mdWelcome = data.mdWelcome;
                $rootScope.community = data.Community;
                $rootScope.dataCommunity = data.DataCommunity;
                $rootScope.didattica = data.DidatticaCompetenze;
                $rootScope.mdUpdate = data.mdUpdate;
                
                if (data.Lingua == 'undefined' || !data.Lingua) {
                    $rootScope.lingua = vm.currentLanguage;   
                } else {
                    $rootScope.lingua = data.Lingua;
                    $translate.use($rootScope.lingua);
                    vm.currentLanguage = $rootScope.lingua;
                }

                if ($rootScope.userRoles[0] == 'STAK') {
                    data.Risorsa = data.Username; //+ ' (' + data.Risorsa + ')';
                    $rootScope.bOperatore = data.bOperatore;
                    $rootScope.bAmministratore = data.bAmministratore;
                }       

                //console.info('lingua utente', $rootScope.lingua);
                if($rootScope.userRoles[0] == 'COMMERCIAL') {
                    //il commerciale loggato
                    $rootScope.commerciale = getCommerciale();
                }               

                return vm.user = data;
            });
        }

        function setRuolo(role) {
            if (role == "STUDENTE") {
                role = $translate.instant('Studente');
            } else if (role == "DOCENTE") {
                role = $translate.instant('Docente');
            } //else if (role == "STAK") {
            //    role = $translate.instant('Stakeholder');
            //}

            return role.toUpperCase();
        }

        $rootScope.isAuthorized = function (role) {
            return $rootScope.userRoles != undefined && $rootScope.userRoles != null && $rootScope.userRoles.indexOf(role) !== -1;
        };

        $rootScope.getWhoAmI = WhoAmI;

        function getCommerciale() {
            return datacontext.commerciale_getByUsername().then(function (data) {
                if (typeof (data) == 'undefined' || data == null)
                    return $rootScope.commerciale = [];
                else
                    return $rootScope.commerciale = data;
            });
        }
    }
})();